/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request model for formatting a problem statement.
 * @export
 * @interface FormatStatementRequest
 */
export interface FormatStatementRequest {
    /**
     * 
     * @type {string}
     * @memberof FormatStatementRequest
     */
    text: string;
}

/**
 * Check if a given object implements the FormatStatementRequest interface.
 */
export function instanceOfFormatStatementRequest(value: object): value is FormatStatementRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function FormatStatementRequestFromJSON(json: any): FormatStatementRequest {
    return FormatStatementRequestFromJSONTyped(json, false);
}

export function FormatStatementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormatStatementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function FormatStatementRequestToJSON(json: any): FormatStatementRequest {
    return FormatStatementRequestToJSONTyped(json, false);
}

export function FormatStatementRequestToJSONTyped(value?: FormatStatementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

